import { render, staticRenderFns } from "./CrsDialog.vue?vue&type=template&id=fba944ba&scoped=true"
import script from "./CrsDialog.vue?vue&type=script&lang=js"
export * from "./CrsDialog.vue?vue&type=script&lang=js"
import style0 from "./CrsDialog.vue?vue&type=style&index=0&id=fba944ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba944ba",
  null
  
)

export default component.exports